import React from 'react';

interface IntroWizardProps {
  onComplete: () => void;
}

const IntroWizard: React.FC<IntroWizardProps> = ({ onComplete }) => {
  return (
    <div className="fixed inset-0 bg-primary-900/40 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-fade-in">
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden animate-slide-up">
        <div className="px-8 pt-8 pb-6 text-center">
          <div className="w-14 h-14 mx-auto mb-5 rounded-xl bg-primary/10 flex items-center justify-center">
            <svg className="w-7 h-7 text-primary-700" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09z" />
            </svg>
          </div>
          <h2 className="text-xl font-bold text-primary-900 mb-2">NNU AI Chatbot</h2>
          <p className="text-sm text-primary-500 leading-relaxed">
            This is the admin panel for NNU's chatbot. Upload documents, manage university data, and the chatbot answers student questions using that data — in Arabic and English.
          </p>
        </div>
        <div className="px-8 pb-8">
          <button
            onClick={onComplete}
            className="w-full bg-primary hover:bg-primary-dark text-primary-900 font-semibold text-sm px-6 py-2.5 rounded-lg transition-colors"
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
};

export default IntroWizard;
